import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";
import {SubscribeComponent} from "../../common/subscribe/subscribe.component";

@Component({
  selector: 'app-about',
  standalone: true,
    imports: [
        RouterLink,
        SubscribeComponent
    ],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {

}
